import React from 'react';
import './Loading.css';

export function Loading(props) {

    const { message } = props;

    return (
        <div className="progressContainer" role="progressbar">
            <svg
                width="60"
                height="60"
                className="progressSvg"
                viewBox="0 0 60 60">
                <circle
                    className="progressCircle"
                    cx="30" 
                    cy="30"
                    r="25" 
                    fill="none" 
                    stroke="#ddd"
                    strokeWidth="5" />
            </svg>
            <p className="loading-message">{message}</p>
        </div>);
}